import React, { useState } from "react";
import { useSidebar } from "../context/SidebarOpenContext";
import PurchaseBillsPage from "./purchasebills";
import IssueEntries from "./issues_entries";

export default function StockUsagePage() {
    const [activeTab, setActiveTab] = useState("purchase");
    const { isSidebarOpen } = useSidebar();

    return (
        <div className={`${isSidebarOpen ? "p-4 sm:ml-64" : "p-4"} bg-content-bg min-h-screen mt-14`}>
            <div className="bg-white rounded-lg shadow-md p-4">
                {/* Tabs Navigation */}
                <div className="flex border-b border-gray-200 mb-4">
                    <button
                        onClick={() => setActiveTab("purchase")}
                        className={`py-3 px-6 font-bold text-sm transition-all border-b-2 ${
                            activeTab === "purchase"
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        PURCHASE BILL ENTRY
                    </button>
                    <button
                        onClick={() => setActiveTab("issue")}
                        className={`py-3 px-6 font-bold text-sm transition-all border-b-2 ${
                            activeTab === "issue"
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        ISSUE ENTRIES
                    </button>
                </div>

                {/* Tab Content */}
                <div className="mt-2">
                    {activeTab === "purchase" ? (
                        <PurchaseBillsPage isTabbed={true} />
                    ) : (
                        <IssueEntries isTabbed={true} />
                    )}
                </div>
            </div>
        </div>
    );
}